/**
 * NOTE: 年末調整（YearEndAdjustment）パッケージ一覧用 route-local mock データ。
 * バックエンド API 対応後は本ファイルごと削除する。
 */
import type { PatternConfigData } from '@/features/boe-task/-query/usePackagePatternDetail';
import type { OperationPackageCountInProgressResponse, OperationPackagePatternsResponse, OperationPackagesResponse, OperationTaskCountInProgressResponse } from '@/features/operation-packages/api';
import { MOCK_YEA_OPERATION_PACKAGE_ID, MOCK_YEA_PATTERN_ID } from '../../-shared/yearEndAdjustmentMockIds';
import { MOCK_YEA_DOCUMENT_STEPS, MOCK_YEA_INSTANCE_COUNT } from '../../-shared/yearEndAdjustmentMockInstances';
export type MockYearEndAdjustmentOperationPackage = Omit<OperationPackagesResponse[number], 'packageType'> & {
  packageType: 'YearEndAdjustment';
};
export type MockOperationPackagesResponse = Array<MockYearEndAdjustmentOperationPackage | OperationPackagesResponse[number]>;

/** 実 API 一覧に差し込む YEA パッケージ（兄弟ダミーは含めない） */
export const MOCK_YEA_OPERATION_PACKAGE = {
  operationPackageId: MOCK_YEA_OPERATION_PACKAGE_ID,
  name: '年末調整',
  description: '年末調整の手続きを管理します',
  packageType: 'YearEndAdjustment',
  packageClass: 'InHouse'
} satisfies MockYearEndAdjustmentOperationPackage;

// NOTE: 実 API は「進行中件数」だが、デモでは起動画面テーブルの表示行数と
// 一致させるため総数を返す（バッジと中身の不一致を防ぐ）。
export const MOCK_YEA_COUNT_IN_PROGRESS: OperationPackageCountInProgressResponse = {
  count: MOCK_YEA_INSTANCE_COUNT
};
export const MOCK_YEA_PATTERNS = [{
  operationPackagePatternId: MOCK_YEA_PATTERN_ID,
  name: '通常',
  anchorDateLabel: '基準日',
  anchorDateDescription: null,
  description: '通常の年末調整パターンです'
}] as const satisfies OperationPackagePatternsResponse;
export const MOCK_YEA_PATTERN_CONFIG = {
  id: MOCK_YEA_PATTERN_ID,
  packageName: MOCK_YEA_OPERATION_PACKAGE.name,
  packageType: MOCK_YEA_OPERATION_PACKAGE.packageType,
  patternName: MOCK_YEA_PATTERNS[0].name,
  description: MOCK_YEA_PATTERNS[0].description,
  anchorDateLabel: MOCK_YEA_PATTERNS[0].anchorDateLabel,
  eligibleTargets: [],
  steps: MOCK_YEA_DOCUMENT_STEPS.map(step => ({
    id: step.id,
    name: step.name,
    tasks: []
  }))
} satisfies PatternConfigData;

// NOTE: 同上（パターンタブのバッジもテーブル表示行数に合わせる）
export const MOCK_YEA_PATTERN_TASK_COUNT: OperationTaskCountInProgressResponse = {
  operationPackagePatternId: MOCK_YEA_PATTERN_ID,
  count: MOCK_YEA_INSTANCE_COUNT
};